/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Filter_CountedInputs */

const vi_stocktake_filter_counted = /** @type {(inputs: Stocktake_Filter_CountedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã kiểm`)
};

/**

* @param {Stocktake_Filter_CountedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_filter_counted = /** @type {((inputs?: Stocktake_Filter_CountedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Filter_CountedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_filter_counted(inputs)
});